import Background from "@assets/images/BG.png";
import HeadColored from "@saleor/components/HeadColored";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    footer: {
      color: theme.palette.grey[800],
      marginBottom: "1rem",
      textAlign: "center",
      width: "100%"
    },
    root: {
      gridTemplateColumns: "1fr",
      gap: theme.spacing(3),
      width: "100%",
      minHeight: "100vh",
      overflow: "hidden",
      position: "relative",
      background: `url('${Background}')`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }),
  {
    name: "Layout"
  }
);

const Layout: React.FC = props => {
  const { children } = props;
  const classes = useStyles(props);

  return (
    <div className={classes.root} data-testid="layout-root">
      <HeadColored fixedTop data-testid="head-colored" />
      {children}
      <footer className={classes.footer}>
        COPYRIGHT 2022 SCG PACKAGING. ALL RIGHTS RESERVED.
        <br />
        {process.env.RELEASE_NAME}
      </footer>
    </div>
  );
};

Layout.displayName = "Layout";
export default Layout;
